import React from "react";
import {Button, IconButton} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import {Alert} from "@material-ui/lab";

import {MappedInputValues} from "utils/flowmaster/map_input_values_by_name";

interface InputSwitchNoticeProps {
  previousWorkflowName: string;
  mapped: MappedInputValues;
  onUndo: () => void;
  onClear: () => void;
  onDismiss: () => void;
  disabled?: boolean;
}

const styles = {
  alert: {margin: "8px 0"},
  line: {fontSize: "12px"},
} as const;

function listNames(inputs: MappedInputValues["emptyInputs"]): string {
  return inputs.map(({label, name}) => label || name).join(", ");
}

const InputSwitchNotice: React.FC<InputSwitchNoticeProps> = ({
  previousWorkflowName,
  mapped,
  onUndo,
  onClear,
  onDismiss,
  disabled = false,
}) => {
  const {copiedCount, emptyInputs, droppedInputs} = mapped;
  const totalCount = copiedCount + emptyInputs.length;
  return (
    <Alert
      severity={emptyInputs.length > 0 ? "warning" : "info"}
      icon={false}
      style={styles.alert}
      action={
        <>
          <Button size="small" onClick={onUndo} disabled={disabled}>
            Undo
          </Button>
          <Button size="small" onClick={onClear} disabled={disabled}>
            Clear inputs
          </Button>
          <IconButton size="small" onClick={onDismiss} aria-label="Dismiss">
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      }
    >
      <div style={styles.line}>
        Copied {copiedCount} of {totalCount} input values from &quot;
        {previousWorkflowName}&quot;
      </div>
      {emptyInputs.length > 0 && (
        <div style={styles.line}>Needs a value: {listNames(emptyInputs)}</div>
      )}
      {droppedInputs.length > 0 && (
        <div style={styles.line}>Not copied: {listNames(droppedInputs)}</div>
      )}
    </Alert>
  );
};

export default InputSwitchNotice;
